import PropTypes, { string } from 'prop-types';

export default {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  loading: PropTypes.bool,
  data: PropTypes.array,
  defaultData: PropTypes.array,
  setData: PropTypes.func,
  meta: PropTypes.object,
  isChipsColored: PropTypes.bool,
  menuPlacement: string
};
